module.exports = __webpack_public_path__ + "media/TennisBalls2.c2c3eec7.mp4";